// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__nmh0r","footerContent":"Footer_footerContent__X6dQ2","copyright":"Footer_copyright__m+9hI"};